module.exports = __webpack_public_path__ + "static/media/fly0207.f0dd8879.webp";